const contribute = [{"key":"contribute.greeting","string":"Zde je náhled Vašeho příspěvku. "},{"key":"contribute.logout","string":"Odhlásit"}]

export default contribute



// WEBPACK FOOTER //
// ./src/i18n/cs/contribute/_contribute.js